import lazyLoading from './lazyLoading'

export default {
  name: 'employees',
  path: '/config-employees',
  component: lazyLoading('config/EmployeesList'),
  meta: {
    default: false,
    title: 'Empleados',
    iconClass: 'vuestic-icon vuestic-icon-user',
    expanded: false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/employees.js